<template>
  <div class="main">
    <div class="query-item">
      <div class="search-l">

        <div class="search-filters">
          <div style="margin-right: 30px;">
            企业名称
            <a-input class="inp ml10" placeholder="请输入" v-model:value="query.enterpriseName"></a-input>
          </div>
          <div>
            状态
            <a-select class="inp ml10" placeholder="请选择" v-model:value="query.status">
              <a-select-option value="">全部</a-select-option>
              <a-select-option value="0">待提交</a-select-option>
              <a-select-option value="1">材料审核中</a-select-option>
              <a-select-option value="2">受理中</a-select-option>
              <a-select-option value="3">待提交联席工作小组审核</a-select-option>
              <a-select-option value="4">联席工作小组审核中</a-select-option>
              <a-select-option value="5">已通过</a-select-option>
              <a-select-option value="6">资质已失效</a-select-option>
            </a-select>
          </div>
          <div class="ml30">
            申请时间
            <a-range-picker class="inp ml10"
                            v-model:value="query.applyDateRange"
                            format="YYYY-MM-DD"></a-range-picker>
          </div>

          <!-- 新增：更多操作按钮 -->
          <!--          <a-button class="ml30" @click="showMoreFilters = !showMoreFilters" type="primary" ghost>-->
          <!--            {{ showMoreFilters ? '收起' : '更多' }}-->
          <!--          </a-button>-->

          <a-button class="ml30" @click="search" type="primary" ghost>查询</a-button>
          <a-button class="ml24" @click="reset" type="primary" ghost>重置</a-button>
          <div></div>
        </div>
        <div v-if="showMoreFilters" class="search-filters">
          <div>

          </div>
        </div>
      </div>
      <div class="search-r">
        <a-button v-if="store.hasPermi('application:form')" class="ml30" type="primary" @click="goApply">+ 道路测试示范运营申请</a-button>
        <a-button v-if="store.hasPermi('application:meeting')" class="ml30" type="primary" @click="goMeeting"> 会议评审 </a-button>
      </div>
    </div>

    <a-table :columns="columns" :row-key="(record) => record.id"
             :data-source="dataSource" size="middle" class="mt23" :pagination="pagination" :scroll="{ y: 'auto', }"
             v-autoHeight="{ extraHeight: 88, trHeight: 47 }"
             :row-selection="{
               selectedRowKeys: selectedRowKeys,
               onChange: onSelectChange,
             }">
      <template #bodyCell="{ column, record, index }">

        <template v-if="column.key === 'category'">
          {{ record.category }}
        </template>
        <template  v-if="column.key === 'applicationVehicleTotal'">
          {{ record.applicationVehicleTotal }}辆
        </template>
        <template v-if="column.key === 'testTime'">
          {{ record.startDate }} 至 {{ record.endDate }}
        </template>
        <template v-if="column.key === 'createTime'">
          {{ moment(record.createTime).format("YYYY-MM-DD HH:mm:ss") }}
        </template>
        <template v-if="column.key === 'status'">
          <template v-if="record.status === -1">
            <span>{{ getStatusView(record.status) }}</span>
            <Tooltip :title="record.comment || '暂无审核意见'" placement="top">
              ?
            </Tooltip>
          </template>
          <template v-else>
            {{ getStatusView(record.status) }}
          </template>
        </template>

        <template v-if="column.key === 'action'">
          <span>
            <a-button v-if="store.hasPermi('application:form') && record.status === 0 || record.status === -1" type="link" @click="editApplyInfo(record)" style="padding: 0">编辑信息</a-button>
            <a-button v-if="record.status > 0" type="link" @click="detail(record)" style="padding: 0">
              <span class="tab-with-badge">
                申请信息
                <span v-if="record.unreceivedDocumentTotal > 0" class="badge">{{ record.unreceivedDocumentTotal > 99 ? '99++' : record.unreceivedDocumentTotal }}</span>
              </span>
            </a-button>
            <a-button :disabled="record.status <= 0" class="ml24" type="link" @click="showProgressDrawer(record)" style="padding: 0">查看进度</a-button>
<!--            <a-button :disabled="record.status !== 5" class="ml10" type="link" @click="delayApplication(record.id)" style="padding: 0">延期申请</a-button>-->
          </span>
        </template>
      </template>
    </a-table>
    <!-- 使用ProgressDrawer组件 -->
    <ProgressDrawer
        v-model:visible="progressDrawerVisible"
        :record="currentRecord"
    />

    <!-- 会议评审弹框 -->
    <a-modal
      v-model:open="meetingModalVisible"
      title="会议评审"
      width="900px"
      @cancel="closeMeetingModal"
      :footer="null"
    >
      <div class="meeting-modal-content">
        <a-form layout="vertical" :model="meetingForm">
          <a-form-item label="会议名称" required>
            <a-input v-model:value="meetingForm.meetingName" placeholder="请输入会议名称" />
          </a-form-item>
        </a-form>

        <div class="selected-list">
          <div class="selected-list-title">已选择的申请信息</div>
          <a-table :columns="selectedColumns" :row-key="(record) => record.id"
                   :data-source="selectedRecords" size="middle"
                   :pagination="false" :scroll="{ y: 'auto' }"
                   v-autoHeight="{ extraHeight: 0, trHeight: 40 }">
          </a-table>
        </div>

        <div class="meeting-modal-footer">
          <a-button @click="closeMeetingModal">取消</a-button>
          <a-button type="primary" @click="createMeeting" :disabled="!meetingForm.meetingName || selectedRecords.length === 0">创建评审会议</a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script setup>
import { ref, onMounted, reactive, computed } from "vue";
import { useRouter } from "vue-router";
import { getStatusView } from '@/utils/applicationUtils'
import { getApplicationPagesByCondition } from "@/api/application/testApplication"
import { createReviewMeeting } from "@/api/application/reviewMeetings"
import ProgressDrawer from './components/ProgressDrawer.vue'
import moment from "moment";
import useUserStore from '@/store/modules/user'
import { Tooltip, Modal, message } from 'ant-design-vue';

const store = useUserStore();
const router = useRouter();

const selectedRowKeys = ref([]);
const meetingModalVisible = ref(false);
const meetingForm = reactive({
  meetingName: ''
});


const columns = [
  {
    title: "申请编号",
    dataIndex: "applicationNo",
    key: "applicationNo",
    width: 190,
  },
  {
    title: "企业名称",
    dataIndex: "deptName",
    key: "deptName",
    width: 180,
  },
  {
    title: "申请类型",
    dataIndex: "categoryName",
    key: "categoryName",
    width: 300,
  },
  {
    title: "车辆识别代码",
    dataIndex: "vin",
    key: "vin",
    width: 220,
  },
  {
    title: "车辆类型",
    dataIndex: "vehicleType",
    key: "vehicleType",
    width: 200,
  },
  {
    title: "申请有效期",
    key: "testTime",
    width: 220,
  },
  {
    title: "状态",
    dataIndex: "status",
    key: "status",
    width: 150,
  },
  {
    title: "申请时间",
    dataIndex: "createTime",
    key: "createTime",
    width: 180,
  },
  {
    title: "操作",
    key: "action",
    width: 240,
  },
];

const selectedColumns = [
  {
    title: "申请编号",
    dataIndex: "applicationNo",
    key: "applicationNo",
    width: 200,
  },
  {
    title: "企业名称",
    dataIndex: "deptName",
    key: "deptName",
    width: 180,
  },
  {
    title: "申请类型",
    dataIndex: "categoryName",
    key: "categoryName",
  },
  {
    title: "车辆识别代码",
    dataIndex: "vin",
    key: "vin",
    width: 200,
  },
];

let dataSource = ref([]);
// 新增控制更多筛选条件显示/隐藏的状态
const showMoreFilters = ref(false);

const selectedRecords = computed(() => {
  return dataSource.value.filter(item => selectedRowKeys.value.includes(item.id));
});

const onSelectChange = (keys) => {
  selectedRowKeys.value = keys;
};
let query = reactive({
  enterpriseName: null,
  status: null,
  applyDateRange: null
});

const pageChange = (page, pageSize) =>{
  pagination.current = page;
  // 获取表格数据
  getData();
}

const pageSizeChange = (current, size) => {
  console.log(size);
  pagination.pageSize = size;
  // 获取表格数据
  getData();
}

const pagination = reactive({
  total: 0,
  size: "middle",
  defaultPageSize: 20,
  current: 1,
  pageSize: 20, //每页中显示10条数据
  showSizeChanger: true,
  showQuickJumper: false,
  pageSizeOptions: ["10", "20", "30"], //每页中显示的数据
  showTotal: (total) => `共有 ${total} 条数据`, //分页中显示总的数据
  onShowSizeChange: (current, pageSize) => (pagination.pageSize = pageSize), // 改变每页数量时更新显示
  onChange: pageChange, //点击页码事件
  showSizeChange: pageSizeChange,
});

const search = () => {
  pagination.current = 1
  getData();
};

const reset = () => {
  query.deptName = null;
  query.status = null;
  query.applyDateRange = null;
  getData();
};

const getData = async () => {

  const queryData = { ...query };
  const data = {
    pageIndex: pagination.current,
    pageSize: pagination.pageSize,
    conditionMap: { ...queryData },
  };
  getApplicationPagesByCondition(data).then((res) => {
    console.log(res);
    if (res.code === 200) {
      dataSource.value = res.data.records || [];
      pagination.total = res.data.total;
    }
  });
};

const goApply = () => {
  router.push({
    path: "/application/category"
  });
}

const goMeeting = () => {
  if (selectedRowKeys.value.length === 0) {
    Modal.warning({
      title: '提示',
      content: '请先选择要评审的申请'
    });
    return;
  }
  sessionStorage.setItem('selectedApplications', JSON.stringify(selectedRecords.value));
  router.push('/application/reviewMeeting');
}

const closeMeetingModal = () => {
  meetingModalVisible.value = false;
}

const createMeeting = async () => {
  const applicationIds = selectedRecords.value.map(record => record.id);
  
  try {
    const response = await createReviewMeeting({
      meetingName: meetingForm.meetingName,
      applicationIds: applicationIds
    });
    
    if (response.code === 200) {
      message.success('评审会议创建成功');
      closeMeetingModal();
      selectedRowKeys.value = [];
    } else {
      message.error(response.message || '创建失败');
    }
  } catch (error) {
    console.error('创建评审会议失败:', error);
    message.error('创建评审会议失败，请重试');
  }
}

const editApplyInfo = (record) => {

  if (record.categoryType === 'intelligent_connected_vehicle') {
    router.push(`/application/intelligent?type=${record.categoryType}&code=${record.categoryCode}&id=${record.id}`);
  }else if (record.categoryType === 'autonomous_vehicle'){
    router.push(`/application/autonomous?type=${record.categoryType}&code=${record.categoryCode}&id=${record.id}`);
  }
}

const detail = (row) => {
  console.log(row)
  router.push({
    path: "/application/detail",
    query: {
      type: "edit",
      id: row.id,
    },
  });
}

// 进度抽屉相关状态
const progressDrawerVisible = ref(false);
const currentRecord = ref(null);

// 显示进度抽屉
const showProgressDrawer = (row) => {
  currentRecord.value = row;
  progressDrawerVisible.value = true;
}

onMounted(async () => {
  await getData();
});

</script>

<style lang="less" scoped>
.inp {
  width: 15.5vw;
}

.query-item {
  display: flex;
  justify-content: space-between;

  .search-l {
    display: flex;
    align-items: center;
  }

  .search-r {
    display: flex;
    align-items: center;
  }
}

.search-filters {
  display: flex;
  padding: 12px;
  border-radius: 4px;
  flex-wrap: wrap;
  align-items: center;
}

/deep/.ant-input::placeholder {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #68767E;
}

/deep/.ant-select-selector {
  background-color: #F2F4F7 !important;
  color: #68767E !important;
}

.main {
  padding: 20px;
  height: calc(100vh - 70px - 57px);
  background-color: #ffffff;
}

/* 徽章样式 */
.tab-with-badge {
  position: relative;
  display: inline-block;
}

.badge {
  position: absolute;
  top: -4px;
  right: -6px;
  min-width: 18px;
  height: 18px;
  padding: 0 6px;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  white-space: nowrap;
  text-align: center;
  background-color: #ff4d4f;
  color: #fff;
  border-radius: 9px;
  transform: translateX(50%);
}

.status-pending {
  color: #FA8C16;  /* 橙色 */
  font-weight: 500;
}

.status-reviewing {
  color: #1E8EF2;  /* 蓝色 */
  font-weight: 500;
}

.status-accepting {
  color: #722ED1;  /* 紫色 */
  font-weight: 500;
}

.status-group-reviewing {
  color: #F5222D;  /* 红色 */
  font-weight: 500;
}

.status-approved {
  color: #52C41A;  /* 绿色 */
  font-weight: 500;
}

.status-default {
  color: #68767E;  /* 默认灰色 */
  font-weight: 500;
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th,
.ant-table-wrapper .ant-table-thead>tr>td {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(10, 33, 46, 1);
  background-color: rgba(239, 240, 245, 1);
}

/deep/.ant-table-wrapper .ant-table:not(.ant-table-bordered) .ant-table-tbody>tr {
  color: rgba(104, 118, 126, 1);
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before,
.ant-table-wrapper .ant-table-thead>tr>td:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  width: 0px;
}

a {
  color: #1E8EF2;
}

.meeting-modal-content {
  .selected-list {
    margin-top: 20px;

    .selected-list-title {
      font-size: 14px;
      font-weight: 500;
      color: #333;
      margin-bottom: 12px;
    }
  }

  .meeting-modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 24px;
    padding-top: 16px;
    border-top: 1px solid #f0f0f0;
  }
}
</style>

.question-icon {
  display: inline-block;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: #e6f7ff;
  text-align: center;
  line-height: 18px;
  font-size: 12px;
  font-weight: bold;
}